import type { ImmutableState, SuggestedTopicState } from '../types.tsx';

export const getSuggestedTopics = (state: ImmutableState): SuggestedTopicState => state.topics;

export const getPageNumber = (state: ImmutableState): number => state.page;
